
export enum OrderState {
  Processing= 'Processing',
  Handled= 'Handled',
  Paid= 'Paid',
  Canceled= 'Canceled',
  NotPaid= 'NotPaid',

}